export default __webpack_public_path__ + "static/media/buzzer-full-red.aae0ed17.png";